import { gsap, ScrollTrigger } from '../global/gsap';

const initHomeHero = (heroEl) => {
    //
};

export { initHomeHero as default };
